// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import ExternalLinkButton from "./ExternalLinkButton-APP_CLIENT";

export default ExternalLinkButton;
